import React from "react";

const EmailMarketing = () => {
  return (
    <>
      <div className="info">
        <p>
          El e-mail marketing es la utilización del correo electrónico con ánimo
          comercial o informativo, es la herramienta más eficaz de marketing
          directo. Para sacarle el máximo provecho debe de estar correctamente
          enfocada y organizada. El envío de newsletters por email es la mejor
          manera de mantener una relación estable a largo plazo con sus clientes
          y clientes potenciales.
          <br /> Permite realizar una oferta personalizada y exclusiva a cada
          persona a través de un medio inmediato, el e-mail. Los resultados se
          pueden medir inmediatamente, aperturas, click y mapa de clicks, esto
          permite saber que ofertas son las mas buscadas o las zonas calientes
          del diseño del E-mail.
        </p>
      </div>
    </>
  );
};

export default EmailMarketing;
